import React, { useState } from 'react';
import Banner from '../Components/Banner';

const faqData = [
  {
    category: "General",
    questions: [
      {
        q: "What is HNH Soft Tech Solutions?",
        a: "HNH Soft Tech Solutions is a global digital agency specializing in web development, mobile applications, AI solutions, digital marketing, UI/UX design, and software consulting. We serve clients across the US, UK, and Pakistan."
      },
      {
        q: "Where are you located?",
        a: "We have offices in multiple regions:\n• USA: 3900 West Northwest Highway, Apt 1172, Dallas, TX 75220\n• UK: Registered UK business address available on request\n• Pakistan: Nazimabad 1E 14/9 karachi— our primary development hub"
      },
      {
        q: "How can I contact your team?",
        a: "You can reach us via:\n• US: +1 972 777-4163 / +1 972 707-4985\n• UK: +44 2045 155008 / WhatsApp: +44 7506 100310\n• Pakistan: +92 340 249 9031\n• Email: info@hnhsofttechsolutions.com"
      },
      {
        q: "Do you work with international clients?",
        a: "Yes! We proudly serve clients across the globe including the United States, United Kingdom, Germany, UAE, and Pakistan. Our team operates across time zones to ensure seamless communication."
      },
    ]
  },
  {
    category: "Services & Pricing",
    questions: [
      {
        q: "What services do you offer?",
        a: "Our core services include: Web Design & Development, Mobile App Development (iOS & Android), AI & Machine Learning Solutions, SEO & Digital Marketing, UI/UX Design, E-Commerce Solutions, Cloud & DevOps, and Business Consulting."
      },
      {
        q: "What is your pricing in PKR?",
        a: "Our service packages in Pakistani Rupees (PKR):\n• Basic Website Package: Starting from PKR 50,000\n• E-Commerce Website: Starting from PKR 120,000\n• Mobile App (Android/iOS): Starting from PKR 200,000\n• UI/UX Design: Starting from PKR 30,000\n• SEO & Digital Marketing (monthly): Starting from PKR 25,000\n• Custom Software / AI Solutions: PKR 300,000+\n\nNote: Final pricing depends on project complexity and requirements. Contact us for a custom quote."
      },
      {
        q: "Do you provide pricing in USD or GBP?",
        a: "Yes. Our international pricing starts at:\n• Basic Website: $300 USD / £250 GBP\n• E-Commerce: $750 USD / £600 GBP\n• Mobile App: $1,200 USD / £950 GBP\n\nAll prices are indicative. We provide detailed quotes after understanding your specific requirements."
      },
      {
        q: "Do you offer custom packages?",
        a: "Absolutely! Every business is unique. We tailor packages to fit your specific needs and budget. Book a free consultation to discuss your project."
      },
    ]
  },
  {
    category: "Project Process",
    questions: [
      {
        q: "How does the project process work?",
        a: "Our process follows 5 key stages:\n1. Discovery & Requirement Analysis\n2. Design & Prototyping\n3. Development & Testing\n4. Review & QA\n5. Launch & Ongoing Support"
      },
      {
        q: "How long does a typical project take?",
        a: "Timelines vary by project scope:\n• Simple Website: 1–2 weeks\n• Complex Website / E-Commerce: 3–6 weeks\n• Mobile App: 6–12 weeks\n• Custom Software: Discussed case by case"
      },
      {
        q: "What information do I need to provide to start?",
        a: "To get started, we'll need: your business description, goals and target audience, any design preferences or references, your budget range, and expected timeline."
      },
      {
        q: "Will I own the source code after project completion?",
        a: "Yes. Upon full payment, all source code and project assets are transferred to you. You own 100% of your project."
      },
    ]
  },
  {
    category: "Payment & Refund",
    questions: [
      {
        q: "What payment methods do you accept?",
        a: "We accept:\n• Bank Transfer (US/UK/Pakistan)\n• PayPal\n• Wise (TransferWise)\n• Credit/Debit Cards\n• Local Pakistan bank transfers (HBL, MCB, Meezan Bank, bank alfalah, UBL, etc.)"
      },
      {
        q: "What is your refund policy?",
        a: "We have a transparent refund policy. If you cancel within 48 hours of deposit and no work has begun, a full refund is issued. For work already initiated, partial refunds are provided based on deliverables completed. Please refer to our Return Policy page for full details."
      },
      {
        q: "Do you offer support after project delivery?",
        a: "Yes! We provide 30 days of free post-launch support for bug fixes. Extended maintenance and support plans are available at additional cost."
      },
    ]
  }
];

const FAQItem = ({ question, answer, isOpen, onClick }) => (
  <div
    className={`service-card-v2 tmponhover mb-4 overflow-hidden transition-all duration-300`}
    style={{ padding: isOpen ? '24px 30px' : '15px 30px' }}
  >
    <button
      onClick={onClick}
      className="w-full flex justify-between items-center text-left gap-4 bg-transparent border-0 p-0"
    >
      <h2 className="service-card-num" style={{ fontSize: '20px', marginBottom: 0 }}>{question}</h2>
      <span className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${isOpen ? 'bg-[#e74c3c] rotate-45' : 'bg-gray-100'}`}>
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M7 1V13M1 7H13" stroke={isOpen ? '#fff' : 'currentColor'} strokeWidth="2" strokeLinecap="round" />
        </svg>
      </span>
    </button>
    <div
      className="transition-all duration-300 overflow-hidden"
      style={{ maxHeight: isOpen ? '400px' : '0', opacity: isOpen ? 1 : 0 }}
    >
      <p className="service-para mt-4 mb-0 leading-relaxed whitespace-pre-line">
        {answer}
      </p>
    </div>
  </div>
);

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState({ cat: 0, q: 0 });

  const toggle = (catIdx, qIdx) => {
    setOpenIndex(prev =>
      prev.cat === catIdx && prev.q === qIdx ? { cat: -1, q: -1 } : { cat: catIdx, q: qIdx }
    );
  };

  return (
    <>
      <Banner heading="FAQs" text="FAQs" />
      <div className="tmp-section-gap">
        <div className="container">
          {/* Header */}
          <div className="text-center mb-14 section-head">
            <div className="section-sub-title center-title">
              <span className="subtitle">Got Questions?</span>
            </div>
            <h2 className="title split-collab mt-2">Frequently Asked <span style={{ color: '#e74c3c' }}>Questions</span></h2>
            <p className="service-para mt-4 max-w-2xl mx-auto">
              Everything you need to know about HNH Soft Tech Solutions — our services, pricing, process, and policies for clients across the US, UK, and Pakistan.
            </p>
          </div>

          {faqData.map((section, catIdx) => (
            <div key={catIdx} className="mb-12">
              <div className="flex items-center gap-3 mb-6">
                <div className="h-px flex-1 bg-gray-200" />
                <h3 className="service-card-num px-4 mb-0 text-2xl">
                  {section.category}
                </h3>
                <div className="h-px flex-1 bg-gray-200" />
              </div>
              {section.questions.map((item, qIdx) => (
                <FAQItem
                  key={qIdx}
                  question={item.q}
                  answer={item.a}
                  isOpen={openIndex.cat === catIdx && openIndex.q === qIdx}
                  onClick={() => toggle(catIdx, qIdx)}
                />
              ))}
            </div>
          ))}

          {/* CTA */}
          <div className="service-card-v2 text-center py-10 px-6 mt-12">
            <h3 className="service-card-num mb-3">Still have questions?</h3>
            <p className="service-para mb-6">Our team is happy to help. Reach out and we'll get back to you within 24 hours.</p>
            <a href="/contact" className="tmp-btn btn-primary">Contact Us</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;
